/**
 * React 書式 css
 */
export const DialogStyles = {
  width: "100%",
  maxWidth: " 800px",
  margin: "0",
  overflowY: "auto",
};
